import { Box, Button, Container, Heading, Stack, VStack, Text, Image, Flex } from '@chakra-ui/react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import posthog from 'posthog-js';

const HeroSection = () => {
  return (
    <Box bg="linear-gradient(to bottom, white, #fff3c6)" pt={{ base: 20, md: 28 }} pb={{ base: 16, md: 24 }}>
      <Container maxW="1200px">
        <Stack direction={{ base: 'column', lg: 'row' }} gap={{ base: 8, md: 16 }} align="center">
          <Box flex={1} textAlign={{ base: 'center', lg: 'left' }}>
            <Heading
              as="h1"
              textStyle="display"
              mb={6}
              bgGradient="to-r" gradientFrom="brand.dark" gradientTo="brand.secondary"
              bgClip="text"
            >
              Your Home's Best Friend for DIY Projects
            </Heading>
            <Text textStyle="body" color="gray.600" mb={8}>
              Expert guidance for home repairs and DIY projects. From diagnosis to completion, DIYBuddy helps you fix it yourself or connect with the right professional.
            </Text>
            <Stack direction={{ base: 'column', sm: 'row' }} gap={4} justify={{ base: 'center', lg: 'flex-start' }}>
              <ScrollLink to="mailinglist" smooth={true} duration={500} offset={-80}>
                <Button size="lg" variant="solid" px={8}>
                  Stay Updated
                </Button>
              </ScrollLink>
             <RouterLink to="/app">
                             <Button 
                               size="lg"
                               variant="outline"
                               onClick={() => {
                                 console.log('Navigation click event');
                                 posthog.capture('nav_click', { section: 'diy-buddy', view: 'desktop' });
                               }}
                             >
                               <VStack align="center" justify="center" gap={0.5}>
                                 <Text textAlign="center" lineHeight="1">Try the App!</Text>
                                 <Text fontSize="xs" color="gray.500" fontWeight="light" textAlign="center" lineHeight="1">Currently in Alpha</Text>
                               </VStack>
                             </Button>
                           </RouterLink>
            </Stack>
          </Box>
          <Flex flex={1} justify="center">
            <Box
              position="relative"
              width={{ base: "100%", md: "450px" }}
              height={{ base: "300px", md: "400px" }}
              borderRadius="xl"
              overflow="hidden"
              boxShadow="2xl"
              bg="gray.100"
            >
              {/* Placeholder for hero image - replace with actual image */}
              <Flex
                height="100%"
                bg="white"
                align="center"
                justify="center"
                flexDirection="column"
                p={6}
              >
                <Image 
                  src="/images/diybuddyicon.svg" 
                  alt="DIYBuddy Icon" 
                  width={{ base: "150px", md: "200px" }} 
                  height="auto" 
                  mb={4}
                />
                <Text fontWeight="bold" textAlign="center">Home Repair & DIY Made Easy</Text>
              </Flex>
            </Box>
          </Flex>
        </Stack>
      </Container>
    </Box>
  );
};

export default HeroSection;
